__webpack_require__.p = "/static/ws/specials/";